// noinspection SpellCheckingInspection
const IN = Object.freeze({
  btnAddJob: 'in-btn-add-job',
  btnAddProduct: 'in-btn-add-product',
  btnAddStylist: 'in-btn-add-stylist',
  btnDeleteClient: 'in-del-client-btn',
  btnEdit: 'in-btn-edit',
  btnHours: 'in-btn-hours',
  btnPayment: 'in-payment-btn',
  btnSave: 'in-btn-save',
  btnSetup: 'in-btn-setup',
  clientPhone: 'in-client-phone',
  counter: 'in-counter',
  deleteStylist: 'in-delete-stylist',
  hours: 'in-hours',
  inWaitlist: 'in-waitlist',
  jobs: 'in-jobs',
  mainMenu: 'in-main-menu',
  mainSettingsMenu: 'in-main-settings-menu',
  noShow: 'in-no-show',
  onlineBooking: 'online-booking',
  productItem: 'in-product-item',
  role: 'in-role',
  roleDropdown: 'in-role-dropdown',
  salon: 'in-salon',
  serviceItem: 'in-service-item',
  serviceEdit: 'in-service-edit',
  services: 'in-services',
  servicesDropDelete: 'in-services-dropdown-delete',
  serviceSwitcher: 'in-service-switcher',
  smsBanner: 'in-sms-banner',
  staff: 'in-staff',
  stockCb: 'in-stock-cb',
  stockFooter: 'in-stock footer-btn-save',
  textClient: 'in-text-client',
  textDropFirst: 'in-text-dropdown',
  textDropSecond: 'in-text-dropdown second',
  viewAllClients: 'in-view-all-clients',
  colorSettings:'in-color-settings',
});

export default IN;
